import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseCodeInput } from '../components/base-code-input/component.js';

var styles = {"component":"code-input__component_1rnvj","disabled":"code-input__disabled_1rnvj","hasError":"code-input__hasError_1rnvj"};
require('./desktop.css')

var CodeInputDesktop = forwardRef(function (restProps, ref) { return React.createElement(BaseCodeInput, __assign({}, restProps, { ref: ref, stylesInput: styles })); });

export { CodeInputDesktop };
